import { render, staticRenderFns } from "./TierConfig.vue?vue&type=template&id=1f179e89&scoped=true&"
import script from "./TierConfig.vue?vue&type=script&lang=js&"
export * from "./TierConfig.vue?vue&type=script&lang=js&"
import style0 from "./TierConfig.vue?vue&type=style&index=0&id=1f179e89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f179e89",
  null
  
)

export default component.exports